import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslatePipe } from "app/core/i18n/translate.pipe";
import { CellRendererParams } from "app/shared/components/smart-grid/core/interfaces/cell-renderer.interface";
import { requiresRepineo } from "../../../utils/requires-repineo.util";
import { BusinessPartnerBySubRoute } from "../../../../interfaces/busines-partner-by-sub-route.interface";

@Component({
  selector: "app-repineo-status-cell-renderer",
  standalone: true,
  imports: [CommonModule, MatTooltipModule, TranslatePipe],
  template: `
    <span
      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
      [ngClass]="
        needsRepineo()
          ? 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300'
          : 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
      "
      [matTooltip]="
        needsRepineo()
          ? ('routing.SUB_ROUTE_PARTNERS.CELLS.REPINEO_PENDING_TOOLTIP' | t)
          : ('routing.SUB_ROUTE_PARTNERS.CELLS.REPINEO_OK_TOOLTIP' | t)
      "
    >
      {{
        needsRepineo()
          ? ('routing.SUB_ROUTE_PARTNERS.CELLS.REPINEO_PENDING' | t)
          : ('routing.SUB_ROUTE_PARTNERS.CELLS.REPINEO_OK' | t)
      }}
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepineoStatusCellRendererComponent {
  readonly params =
    input.required<CellRendererParams<BusinessPartnerBySubRoute>>();

  readonly needsRepineo = computed(() =>
    requiresRepineo(this.params()?.data?.principalAddress),
  );
}
